define((require, exports, module) => {
    const toolkit = require('toolkit/b-toolkit/b-toolkit');
    const BToolkit = toolkit['b-toolkit'];

    require('toolkit/b-checkbox/b-checkbox');
    require('toolkit/b-input/b-input');
    require('mrg-form/b-form/b-form');

    const BBillingAutopayment = toolkit.create('billing-autopayment', {
        inner: true,

        boundAll: ['_onSubmit', '_onToggle'],

        _form: null,
        _toggler: null,

        _onSubmit() {
            const data = this.getFormData();

            this.emit(BBillingAutopayment.EVENT_SUBMIT, data);
        },

        _onToggle(event, enabled) {
            this._form.toggleMod('billing-autopayment-disabled', !enabled);

            if (!enabled) {
                this._form.setFormData({
                    sum4payment: 1000,
                    limit2life: 100,
                });
            }
        },

        lockForm() {
            const $button = this.$('.js-billing-autopayment-submit');

            $button.toggleMod('main', false);
            $button.toggleMod('spinner', true);

            this._form.toggleMod('disabled', true);
            this._toggler.toggleMod('disabled', true);
        },

        unlockForm() {
            const $button = this.$('.js-billing-autopayment-submit');

            $button.toggleMod('main', true);
            $button.toggleMod('spinner', false);

            this._form.toggleMod('disabled', false);
            this._toggler.toggleMod('disabled', false);
        },

        getFormData() {
            const data = this._form.getFormData();

            data.enabled = this._toggler.hasMod('checked');

            return data;
        },

        onRender() {
            this._form = this.$(
                '.js-billing-autopayment-form .b-form',
            ).getBlock();
            this._form.on('submit', this._onSubmit);

            this._toggler = this.$(
                '.js-billing-autopayment-toggler',
            ).getBlock();
            this._toggler.on('change', this._onToggle);
        },

        destroy() {
            this._form = null;
            this._toggler = null;

            // eslint-disable-next-line prefer-rest-params
            BToolkit.fn.destroy.apply(this, arguments);

            this.destroyed = true;
        },
    });

    BBillingAutopayment.EVENT_SUBMIT = 'Submit';

    module.exports = BBillingAutopayment;
});
